<template>
  <v-card elevation="0" v-if="cuenta">
      <v-col cols="12">
        <div style="background-color: #FFFFFF">
          <p
            v-if="!cuenta.colegiada_observaciones && role=='magistrado' && cuenta.status<=44"
            @click="dialogObsRel = true"
            class=" font-weight-bold text-15" style="color:#1D2E4B">
              Si desea registrar la observación de click en el botón Registrar Observación
              <span class="mx-3"><v-btn small color="#3F5062" dark>Registrar Observación</v-btn></span>
          </p>
          <p
            v-if="cuenta.colegiada_observaciones && role=='magistrado' && cuenta.status<=44"
            @click="dialogObsRel = true, observaciones = cuenta.colegiada_observaciones.observaciones"
           class=" font-weight-bold text-15" style="color:#1D2E4B">
              Si desea actualizar la observación de click en el botón Actualizar Observación
              <span class="mx-3"><v-btn small color="#3F5062" dark>Actualizar Observación</v-btn></span>
          </p>
        <div>
          <v-card
              v-if="cuenta.colegiada_observaciones"
              v-scroll.self="onScroll"
              class="overflow-y-auto"
              max-height="500"
              min-height="150"
              style="background-color: #FFFFFF"
            >
              <v-card-text>
                <div
                    class="black--text text-15"
                  v-html="cuenta.colegiada_observaciones.observaciones"
                >
                </div>
              </v-card-text>

            </v-card>
        </div>
      </div>
    </v-col>

    <v-dialog
      v-model="dialogObsRel"
      max-width="900px"
      persistent
    >
    <v-card class="mx-0">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-toolbar
          color="#286090"
          dark
        >
          <img src="@/assets/logo_nuevo.png" style="width:50px;height:51px" class="mr-4">
          <h2>OBSERVACIONES DE COLEGIADA</h2>
          <v-spacer></v-spacer>
            <v-btn
              icon
              @click="dialogObsRel = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-container class="mt-9" v-if="role == 'magistrado'">
          <v-row>
            <v-col
              cols="12"
              sm="12"
              class="mt-n6"
            >
            <vue-editor
              v-model="observaciones"
              outlined
              name="input-7-4"
              placeholder=""
              required
            ></vue-editor>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn
              class="mb-2"
              color="grey darken-1"
              text
              @click="close()"
            >
              Cerrar
            </v-btn>
            <v-btn
              class="mb-2"
              color="#1D2E4B"
              text
              :loading="loading"
              :disabled="!valid"
              @click="validate"
            >
              GUARDAR
            </v-btn>
        </v-card-actions>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>

  </v-card>

</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import { VueEditor } from 'vue2-editor';
import BaseSelect from "@/components/BaseSelect.vue";
import Autocomplete from "@/components/Autocomplete";

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    role: {
      type: String,
      required: true
    }
  },
  components: { BaseSelect, Autocomplete },
  data: () => ({
    valid: false,
    observaciones:'',
    // disabledMunicipio: true,
    disabled: true,
    dialog:false,
    dialogObsMag:false,
    dialogObsRel:false,
    loading: false,
    scrollInvoked: 0,
    cuenta:null,
    rules: {
      required:v => !!v.trim() || 'Campo requerido',
      requiredSelect:v => !!v|| 'Campo requerido'
    }
  }),
  mounted(){
    this.cuenta = this.item
  },
  computed: {
    showApelacion(){
    },
    ...mapGetters([
      "currentUser",
      "roleUser",
    ]),
  },
  created() {
    this.$store.dispatch("GET_ALL_SENTIDOS", { url: "/sentidos" });
  },
  computed: {
  ...mapGetters(["getAllSentidos","roleUser"])
  },
  methods:{
    onScroll () {
      this.scrollInvoked++
    },
    validate() {
      if (this.$refs.form.validate()) {
          this.loading = true;
          if (this.roleUser == 'magistrado' && !this.observaciones) {
            this.$swal({
              title: "Error",
              text: "Favor de agregar una observación",
              icon: "warning",
              confirmButtonText: "Aceptar"
            });
            this.loading = false;
          }
          else {
            this.save();
          }
      }
    },
    save() {
      if (!this.cuenta.colegiada_observaciones) {
        var observacion = {
          cuenta_id:this.item.id,
          observaciones: this.observaciones
        }
        this.url = '/colegiada/observacion';
        this.action = "CREATE_OBSERVACION_COLEGIADA"
      } else {
        var observacion = {
          colegiada_observaciones_id: this.cuenta.colegiada_observaciones.id,
          cuenta_id:this.item.id,
          observaciones: this.observaciones
        }
        this.url = '/colegiada/observacion';
        this.action = "UPDATE_OBSERVACION_COLEGIADA"
      }
      this.$store.dispatch(this.action, { url: this.url, data:observacion }).then(response => {
          this.loading = false;
            this.$swal({
              title: "Éxito!!!",
              text: "Observaciones actualizadas correctamente.",
              icon: "success",
              confirmButtonText: "Aceptar"
            });
          this.cuenta.colegiada_observaciones = response.data.data.observacion
          this.resetValidation()
          this.close()

        }).catch(error => {
          console.log(error);
          this.loading = false;
          this.$swal({
            title: "Error",
            text: "No se pudo guardar",
            icon: "error",
            confirmButtonText: "Aceptar"
          });
        });
    },
    resetValidation () {
      this.$emit('closeModal');
      this.dialog = false
      this.$refs.form.resetValidation()
      this.numero=""
      this.anio=""
      this.expediente=""
      this.oficio=""
      this.juzgado_id=""
      this.actor=""
      this.demandado=""
      this.materia_apelacion=""
      this.via_id=""
      this.accion_id=""
      this.fecha_recepcion=""
      this.fecha_citacion=""
      this.fecha_turno= ""
      this.has_reconvencion=""
      this.municipio_id=""
      this.tipo_registro=""
      this.materia_id=""
    },
    close () {
    this.dialogObsMag = false
    this.dialogObsRel = false
    // this.$nextTick(() => {
      // this.editedIndex = -1
      this.resetValidation()
      // this.$refs.form.reset()
      // this.editedItem = Object.assign({}, this.defaultItem)

      //this.observaciones = ''
      // this.$emit('close', false);
    // })
    },
    dialogMagistrado() {
      this.dialogObsMag = true,
      this.observaciones_mag_edit = this.observaciones_mag,
      this.sentido_id_edit = this.sentido_id,
      this.fecha_cuenta_edit = this.fecha_cuenta
    },
  }
};
</script>
